import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";

let barChartCompare = [];

const barChart = (canvasId) => {
	const canvasElem = document.getElementById(canvasId);
	const canvasWidth = canvasElem.offsetWidth;
	const windowMedia = window.matchMedia("(min-width: 1024px)");

	const labelsData = JSON.parse(canvasElem.dataset.labels);
	const colorsData = JSON.parse(canvasElem.dataset.colors);
	const valueData = JSON.parse(canvasElem.dataset.value);
	const configData = JSON.parse(canvasElem.dataset.config);
	const urlData = JSON.parse(canvasElem.dataset.urls);

	let barSpacing =
		Math.max(...valueData) * (parseInt(configData.spacing) / 100);

	const barSpacingHalf = barSpacing / 2;

	let textSize = "13px";
	let barSize = 0.525;
	let zIndex = 0;
	let labelOffset = 10;
	// let showMobile = true;
	let showDesktop = false;

	let labelYAlign = -45;
	let labelYOffset = 15;
	let labelYPaddingL = { left: -15 };

	const languagePos = document.dir;

	if(languagePos === 'rtl') {
		canvasElem.dir = "ltr";
	}

	// Desktop
	if (windowMedia.matches) {
		textSize = "15px";
		labelOffset = 20;
		barSize = 0.75;
		zIndex = 1;
		// showMobile = false;
		showDesktop = true;

		labelYAlign = "left";
		labelYOffset = 30;
		labelYPaddingL = 14;
	}

	let newValue = [];

	valueData.map((item) => {
		newValue.push([barSpacingHalf, item]);
	});

	const maxX = configData.max_value;
	const stepSizeCounter = configData.max_value / configData.step_count;

	const ctx = canvasElem.getContext("2d");

	var gradient = ctx.createLinearGradient(0, 0, canvasWidth, 0);
	gradient.addColorStop(0, colorsData.bar_start);
	gradient.addColorStop(1, colorsData.bar_end);

	const data = {
		labels: labelsData,
		datasets: [
			{
				axis: "y",
				label: configData.legend,
				data: newValue,
				backgroundColor: gradient,
				barPercentage: barSize,
				categoryPercentage: barSize,
				barThickness: 24,
				datalabels: {
					labels: {
						name: {
							anchor: "start",
							align: labelYAlign,
							offset: labelYOffset,
							padding: labelYPaddingL,
							color: colorsData.label,
							z: 2,
							// display: showMobile,
							display: true,
							font: {
								size: textSize,
								family: configData.family,
								weight: "normal",
							},
							formatter: function (value, context) {
								return context.chart.data.labels[context.dataIndex];
							},
							listeners: {
                                click: function (context) {
									window.location.href = urlData[context.dataIndex];
                                },
								enter: function(context, event) {
									context.hovered = true;
									event.chart.canvas.style.cursor = 'pointer';
									return true;
								},
								leave: function(context, event) {
									context.hovered = false;
									event.chart.canvas.style.cursor = 'default';
									return true;
								}
                            },
							color: function(context) {
								return context.hovered ? colorsData.label_alt : colorsData.label;
							},
						},
						value: {
							anchor: "end",
							align: "left",
							offset: labelOffset,
							color: colorsData.bar_text,
							z: 2,
							font: {
								size: textSize,
								family: configData.family,
								weight: "normal",
							},
							formatter: function (value, context) {
								return value[1];
							},
							
						},
					},
				},
			},
		],
	};

	const config = {
		type: "bar",
		data,
		options: {
			indexAxis: "y",
			devicePixelRatio: 2,
			responsive: true,
			maintainAspectRatio: false,
			font: {
				size: textSize,
				family: configData.family,
				weight: "normal",
			},
			scales: {
				y: {
					beginAtZero: true,
					grid: {
						display: false,
					},
					border: {
						display: false,
					},
					ticks: {
						// color: colorsData.label,
						color: 'transparent',
						display: showDesktop,
						// display: false,
						padding: 14,
						font: {
							size: textSize,
							family: configData.family,
							weight: "normal",
						},
					},
				},
				x: {
					beginAtZero: true,
					max: maxX,
					ticks: {
						color: colorsData.label_x,
						font: {
							size: textSize,
							family: configData.family,
						},
						stepSize: stepSizeCounter,
					},
					grid: {
						color: colorsData.line,
						z: zIndex,
					},
					border: {
						color: "transparent",
						dash: [4, 4],
						dashOffset: 1,
						display: false,
					},
				},
			},
			plugins: {
				legend: {
					display: false,
				},
				tooltip: {
					enabled: false,
				},
			},
			
		},
		plugins: [ChartDataLabels],
	};
	barChartCompare.push(new Chart(canvasElem, config));
};

const barChartInit = () => {
	const barChartItems = document.querySelectorAll(".js-bar-chart");

	for (let i = 0; i < barChartItems.length; i++) {
		const canvasId = barChartItems[i].getAttribute("id");
		barChart(canvasId);
	}
};

document.addEventListener("DOMContentLoaded", function () {
	document.fonts.ready.then(function() {
		barChartInit();
	}).catch(function(error) {
		console.error('Font loading failed:', error);
	});
});

window.addEventListener(
	"resize",
	function (event) {
		for (let i = 0; i < barChartCompare.length; i++) {
			barChartCompare[i].destroy();
		}
		barChartInit();
	},
	true
);
